import React, { useCallback, useContext } from 'react';

import { VitalSignsContext } from '../../vital-signs.context';
import DialogVitalSignForm from '../Form/DialogVitalSign';

export default function EditDialog() {
  const { editDialogOpened, setEditDialogOpened, selectedData, reload } = useContext(VitalSignsContext);
  const closeDialog = useCallback(
    (success: boolean) => {
      if (success) {
        reload();
      }
      setEditDialogOpened(false);
    },
    [reload, setEditDialogOpened]
  );

  return <DialogVitalSignForm open={editDialogOpened} onClose={closeDialog} data={selectedData} />;
}
